import { render, staticRenderFns } from "./PDFclienteInfo.vue?vue&type=template&id=11b8e90b&scoped=true&"
import script from "./PDFclienteInfo.vue?vue&type=script&lang=js&"
export * from "./PDFclienteInfo.vue?vue&type=script&lang=js&"
import style0 from "./PDFclienteInfo.vue?vue&type=style&index=0&id=11b8e90b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b8e90b",
  null
  
)

export default component.exports